module.exports = __webpack_public_path__ + "static/img/c1.e2f279ae.png";